import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IImage } from 'shared';

import { ImageViewerComponent } from '../components/modals/image-viewer/image-viewer.component';
import { DomService } from './dom.service';

export interface ImageViewerOptions {
    onDelete?: (image: IImage) => Observable<void>;
}

@Injectable({
    providedIn: 'root',
})
export class ImageViewerService {
    private readonly domService = inject(DomService);

    public openImages(images: Array<IImage>, index: number, options?: ImageViewerOptions): void {
        const comp = this.domService.appendComponentTo<ImageViewerComponent>(
            'overlay-container',
            ImageViewerComponent,
            {
                images,
                onDelete: options?.onDelete,
            }
        );
        comp.component.currentImageIndex$.next(index || 0);
    }
}
